import apiService from './apiService';

export const getSites = async () => {
  try {
    const response = await apiService.get(`/sites`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sites:', error);
    throw error;
  }
};

export interface SitePayload {
  name: string;
  type: number;
  code: string;
  description: string;
}

export const createSite = async (payload: SitePayload) => {
  const response = await apiService.post('/sites', payload);
  return response.data?.data ?? response.data;
};

export const updateSite = async (id: number, payload: SitePayload) => {
  const response = await apiService.put(`/sites/${id}`, payload);
  return response.data?.data ?? response.data;
};

export const deleteSite = async (id: number) => {
  const response = await apiService.delete(`/sites/${id}`);
  return response.data;
};
